export type {
    SheetBlockState,
    SheetBlockLine,
    LineVisibility,
    LineWidth,
} from './2'
export {
    VISIBILITY_STATES,
    WIDTH_STATES,
    fromJSON,
    toJSON,
} from './2'